module.exports = __webpack_public_path__ + "static/media/petunjuk_wawancara.25a114bb.png";